import React from 'react'
import PropTypes from 'prop-types'
import { LuAlertTriangle, LuXCircle, LuInfo, LuPencil, LuTrash2 } from "react-icons/lu"

const ALERT_COLORS = {
  warning: {
    bg: 'bg-warning-light',
    border: 'border-warning-main',
    text: 'text-warning-main',
    icon: 'text-warning-main'
  },
  critical: {
    bg: 'bg-error-light',
    border: 'border-error-main',
    text: 'text-error-main',
    icon: 'text-error-main'
  },
  info: {
    bg: 'bg-info-light',
    border: 'border-info-main',
    text: 'text-info-main',
    icon: 'text-info-main'
  }
}

const AlertItem = ({ alert, canManage, onEdit, onDelete }) => {
  const colors = ALERT_COLORS[alert.type] || ALERT_COLORS.info

  const getAlertIcon = (type) => {
    const cls = `${colors.icon}`
    if (type === 'warning') return <LuAlertTriangle size={20} className={cls} />
    if (type === 'critical') return <LuXCircle size={20} className={cls} />
    return <LuInfo size={20} className={cls} />
  }

  return (
    <div
      className={`flex items-center px-4 py-3 rounded-lg border-l-4 ${colors.bg} ${colors.border} relative group`}
    >
      <div className="flex-shrink-0 mr-3">
        {getAlertIcon(alert.type)}
      </div>
      <p className={`flex-1 text-sm font-medium ${colors.text}`}>
        {alert.message}
      </p>

      {/* Edit/Delete actions on hover */}
      {canManage && (
        <div className="flex items-center gap-2 ml-4 opacity-0 group-hover:opacity-100 transition-opacity">
          <button
            onClick={onEdit}
            className="p-1 rounded hover:bg-black/[0.06] dark:hover:bg-white/[0.10] transition-colors"
            title="Edit alert"
          >
<LuPencil size={16} className="text-text-secondary" />
          </button>
          <button
            onClick={onDelete}
            className="p-1 rounded hover:bg-black/[0.06] dark:hover:bg-white/[0.10] transition-colors"
            title="Delete alert"
          >
<LuTrash2 size={16} className="text-text-secondary" />
          </button>
        </div>
      )}
    </div>
  )
}

AlertItem.propTypes = {
  alert: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['warning', 'critical', 'info']).isRequired,
    expiresAt: PropTypes.string,
  }).isRequired,
  canManage: PropTypes.bool,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
}

AlertItem.defaultProps = {
  canManage: false,
  onEdit: () => {},
  onDelete: () => {},
}

export default AlertItem
